export const TATStatusLegend = () => {
  return (
    <div className="px-6 py-3 bg-muted/30 border-y border-border">
      <div className="flex items-center gap-6 text-xs flex-wrap">
        <span className="font-medium text-muted-foreground">TAT Status:</span>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-success"></div>
          <span>Green - Within threshold</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-warning"></div>
          <span>Yellow - Level 1 breach</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-destructive"></div>
          <span>Red - Level 2 breach</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-destructive ring-2 ring-destructive/50"></div>
          <span>Exceeded - Beyond allowed TAT</span>
        </div>
      </div>
    </div>
  );
};
